module.exports = __webpack_public_path__ + "img/ic_hamburger.6ce96ac0.svg";